<template>
  <div>
    <FieldsetModel
      :ui="uiBaseFieldset"
      :name="FIELDSET_NAMES.ibanFieldSet"
      :ui-title="title"
      :ui-subtitle="subtitle"
    >
      <UiWrapper :name="FIELD_NAMES.IBAN" :label="label"  :validations="validations">
        <InputText :prefix="prefix" :maxlength="maxlength" />
      </UiWrapper>
    </FieldsetModel>
  </div>
</template>

<script>
import { InputText } from "@dunia/ui";
import * as conditions from "@/forms/conditions";
import {
  DIGIT_CHARS,
  IBAN_NUMBER_LENGTH
} from "@/forms/constants/onboarding-logic";
import sharedComponentMixin from "@/forms/components/shared/shared-component-mixin";
export default {
  name: "FieldsetIBAN",

  props: {
    title: {
      type: String,
      default: "IBAN"
    },
    subtitle: {
      type: String
    },
    label: {
      type: String,
      default: "Enter IBAN"
    },

    prefix: {
      type: String,
      default: "AE"
    },
    maxlength: {
      type: Number,
      default: 21
    },
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-iban-only-digits"
        },

        {
          errorMessage: "Your IBAN must have 21 digits",
          condition: conditions.patternCondition(IBAN_NUMBER_LENGTH),
          name: "check-is-iban-length"
        }
      ]
    }
  },

  mixins: [sharedComponentMixin],

  data: () => ({
    IBAN_NUMBER_LENGTH,
    DIGIT_CHARS
  }),

  components: {
    InputText
  }
};
</script>
